import { IntroSubContent } from "../components/pages/intro/intro.model"
import { Injectable } from "@angular/core"

@Injectable({
  providedIn: "root",
})
export class DetroitMiRegion {

  localVideo(): IntroSubContent {
    return {
      image: {
        altText: "",
        srcDarkMode: "",
        srcLightMode: "",
        style: {},
      },
      video: {},
      style: {},
      contents: [],
      subTitle: "",
      value: "",
    }
  }

  brandHeader(): IntroSubContent {
    return {
      contents: [],
      video: {},
      title: "Detroit",
      subTitle: "presented in partnership with",
      image: {
        altText: "",
        srcDarkMode: "assets/regions/detroit_mi/brand-logo.png",
        srcLightMode: "assets/regions/detroit_mi/brand-logo.png",
        style: {},
      },
      style: {
        width: "360px",
      },
    }
  }

}
